import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { EuserContext } from "../data/providers/EuserProvider";
import { notify } from "../utils/notify";

type Props = { check: () => boolean };

// Route-level auth guard.  Wrap protected routes in App.tsx; for example:
//
//   <Route element={<RequireRole check={euserIsAdmin} />}>
//     <Route path="..." element={<AdminPage />} />
//   </Route>
//
// Use check={() => true} to require only authentication (any role).
export const RequireRole = ({ check }: Props) => {
  const { euser } = useContext(EuserContext);

  // Not authenticated — send to sign-in
  if (!euser) {
    return <Navigate to="/account/signin" replace />;
  }

  // Authenticated but wrong role
  if (!check()) {
    notify.persistToast({
      message:
        "Looks like you don't have access to that page.\n\nIf you need assistance, please contact us at golfforhope@hcahealthcare.com.",
      type: "error",
      extraOptions: { style: { whiteSpace: "pre-line" } },
    });
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
